<template>
  <NdsTooltip
    :content="tooltip ?? ''"
    :enabled="isTextOverflowing && !!tooltip"
  >
    <div
      ref="clampedText"
      class="ndsLineClamp"
      @mouseover="handleIsOverflowing"
    >
      <slot />
    </div>
  </NdsTooltip>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import NdsTooltip from '@/components/NewDesignSystem/NdsTooltip/NdsTooltip.vue'

defineProps({
  maxLines: {
    type: Number,
    required: true,
  },
  tooltip: {
    type: String,
    default: null,
  },
})

const clampedText = ref<HTMLElement | null>(null)
const isTextOverflowing = ref<boolean>(false)

const handleIsOverflowing = () => {
  isTextOverflowing.value = false

  if (clampedText.value) {
    isTextOverflowing.value = clampedText.value.scrollHeight > clampedText.value.clientHeight
  }
}

defineExpose({ isTextOverflowing })
</script>

<style lang="postcss" scoped>
.ndsLineClamp {
  display: -webkit-box;
  line-clamp: v-bind(maxLines);
  -webkit-box-orient: vertical;
  -webkit-line-clamp: v-bind(maxLines);
  overflow: hidden;
  overflow-wrap: break-word;
  flex: 1;
  max-width: 100%;
}
</style>
